@import 'apps/webcomponents/src/assets/common.scss';

#activate-recursive-toggle {
  margin-top: 16px;
}

.activate-recursive-text {
  margin-top: 8px;
  color: dimgrey;
}
